import SequenceNumberListModelBase from '../_generated/modelBases/sequence-number-list-model-base';

export default class SequenceNumberListModel extends SequenceNumberListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
